import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { BaseSiteService, ProductActions, ProductScope, StateWithProduct, UserIdService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface NotifyMePayload {
  active: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class NotifyMeService {
  baseSite$: Observable<string> = this.baseService.getActive();
  userCurrent$: Observable<string> = this.auth.getUserId();
  activeCart$: Observable<string> = this.cartService.getActiveCartId();
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  url = `${this.occUrl.content}${environment.prefix}${this.baseSiteId}`;

  constructor(
    protected http: HttpClient,
    protected baseService: BaseSiteService,
    protected auth: UserIdService,
    protected cartService: ActiveCartFacade,
    protected store: Store<StateWithProduct>,
    private meta: Meta
  ) {}

  get baseSiteId(): string {
    let baseSiteId: string;
    this.baseSite$.pipe(take(1)).subscribe((baseSiteData) => (baseSiteId = baseSiteData));
    return baseSiteId;
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  get activeCartId() {
    let activeCartId: string;
    this.activeCart$.pipe(take(1)).subscribe((activeCart) => (activeCartId = activeCart));
    return activeCartId;
  }

  updateNotifyMe(payload: NotifyMePayload, productCode: string, active: boolean): Observable<any> {
    return this.http.put<any>(`${this.url}/products/${productCode}/notifyMe`, payload, {
      params: {
        active,
      },
    });
  }

  loadProduct(productCode: string) {
    this.store.dispatch(new ProductActions.LoadProduct(productCode, ProductScope.DETAILS));
  }
}
